export default {
      id: "box-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#box-usage",
      toString: function () {
        return this.url;
      }
    }